{
  "title": "Меню",
  "copyright": "Всі права захищені © {{year}}",
  "disclaimer": "Результати діагностики мають інформаційний характер і не є діагнозом. За потреби вони можуть стати приводом для консультації з фахівцем з ментального здоров’я.",
  "email": "info@healthymind.help",
  "links": [
    {
      "text": "Про Healthy Mind",
      "href": "https://healthymind.help"
    },
    {
      "text": "Умови використання",
      "href": "https://healthymind.help/terms"
    },
    {
      "text": "Політика обробки даних",
      "href": "https://healthymind.help/privacy"
    },
    {
      "text": "Напишіть нам"
    }
  ]
}
